import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { NoticeListItem, NoticeListParams } from '~/features/notices/types/notices.type';

/**
 * 공지사항/FAQ 목록 조회
 * @endpoint GET /notices
 */
export function getNoticesApi(params?: NoticeListParams) {
  return axiosInstance.get<PaginatedApiResponse<NoticeListItem>>('/notices', {
    params,
  });
}
